/**
 * Ordena uma lista de objetos contendo nomes em ordem alfabética.
 * @param {Array} list - Uma lista de objetos contendo uma propriedade 'name'.
 * @returns {Array} Uma nova lista de objetos ordenados alfabeticamente pelo nome.
 */
const SortListAlphabeticallyByName = (list) =>
{
	return [ ...list ].sort((a, b) => a.name.localeCompare(b.name));
};

export default { SortListAlphabeticallyByName };